<template>
  <div>
    <div>車牌號碼：{{ engravingContent.commemorativeLicensePlateNumber }}</div>
    <div>車牌圖片：{{ commemorativeLicensePlateImageDisplayLabel }}</div>
    <div
      v-if="
        this.engravingContent.commemorativeLicensePlateImageOption === 'text'
      "
    >
      文字：{{ engravingContent.commemorativeLicensePlateImageText }}
    </div>
    <div
      v-if="
        this.engravingContent.commemorativeLicensePlateImageOption === 'custom'
      "
    >
      圖片描述：{{ engravingContent.commemorativeLicensePlateImageCustom }}
    </div>
    <div>
      反面文字：{{ engravingContent.commemorativeLicensePlateReverseText }}
    </div>
  </div>
</template>
<script>
import { commemorativeLicensePlateImageOptions } from "@/constData/engravingData";
export default {
  name: "display_commemorative_license_plate",
  props: {
    engravingContent: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      commemorativeLicensePlateImageOptions:
        commemorativeLicensePlateImageOptions,
    };
  },
  computed: {
    commemorativeLicensePlateImageDisplayLabel() {
      const option = commemorativeLicensePlateImageOptions.find(
        (option) =>
          option.value ===
          this.engravingContent.commemorativeLicensePlateImageOption
      );
      return option ? option.label : "";
    },
  },
};
</script>
<style scoped lang="scss">
div {
  margin: 6px 0;
}
</style>
